// theme.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  constructor(private http: HttpClient) {}

  loadTheme(blobUrl: string): void {
    if (!blobUrl) {
      console.warn('No theme URL provided, using default theme from index.html');
      return;
    }

    // Use <link> tag instead of HttpClient to avoid CORS issues
    // CSS loaded via <link> tags don't require CORS headers
    let themeLink = document.querySelector('link[data-theme="dynamic-client-theme"]') as HTMLLinkElement;
    
    if (!themeLink) {
      themeLink = document.createElement('link');
      themeLink.rel = 'stylesheet';
      themeLink.setAttribute('data-theme', 'dynamic-client-theme');
      document.head.appendChild(themeLink);
    }

    // Error handler - use default theme from index.html
    themeLink.onerror = () => {
      console.error('✗ Failed to load theme from:', blobUrl.substring(0, 80) + '...');
      console.log('Using default theme from index.html');
      // Remove the failed link tag
      themeLink.remove();
    };

    // Success handler
    themeLink.onload = () => {
      console.log('✓ Theme loaded successfully');
    };

    // Add cache buster to prevent conditional headers (If-Modified-Since, If-None-Match)
    // Azure SAS tokens don't support conditional headers and return 400 error
    const separator = blobUrl.includes('?') ? '&' : '?';
    const urlWithCacheBuster = `${blobUrl}${separator}v=${Date.now()}`;
    
    // Set the href to trigger load
    themeLink.href = urlWithCacheBuster;
  }
}